import { createSlice } from '@reduxjs/toolkit';
import { parseCookies } from 'nookies';
import apiClient from 'root/lib/apiClient';
import { Sentry } from 'root/utils/raven';
import getConfig from 'next/config';

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const initialState = {
  results: []
};

const notificationsSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    getNotifications(state, { payload: { data } }) {
      state.results = data.results;
    }
  },
});

export const {
  getNotifications
} = notificationsSlice.actions;

export default notificationsSlice.reducer;

function getRedirect(notification) {
  switch (notification.occasion) {
    case 'new_coupon':
      return `${window.location.origin}/courses/course`;
    case 'booking_cancellation':
      return `${window.location.origin}/consultations/bookings`;
    default:
      if (notification.body.url) {
        return notification.body.url;
      }
      break;
  }
  return '';
}

export const fetchNotifications = (page = 1, onlyNew = false) => async (dispatch) => {
  const userToken = parseCookies().user_token;
  try {
    const response = await apiClient({
      baseURL: publicRuntimeConfig.BASE_API_URL,
      method: 'GET',
      url: '/users/me/notifications',
      params: {
        onlyNew,
        page
      },
      userToken });
    dispatch(getNotifications({
      data: response
    }));
  } catch (e) {
    Sentry.captureException(e);
  }
};

export const markAsRead = (notification) => async () => {
  try {
    const data = {
      ...notification,
      viewed: true
    };

    await apiClient({ baseURL: publicRuntimeConfig.BASE_API_URL, method: 'PUT', url: `/users/me/notifications/${notification._id}`, data }).then(() => {
      window.location = getRedirect(notification);
    });
  } catch (e) {
    Sentry.captureException(e);
  }
};

export const markAllAsRead = () => async (dispatch) => {
  try {
    await apiClient({ baseURL: publicRuntimeConfig.BASE_API_URL, method: 'POST', url: '/users/me/notifications' }).then(() => {
      dispatch(fetchNotifications());
    });
  } catch (e) {
    Sentry.captureException(e);
  }
};
